module.exports = __webpack_public_path__ + "static/media/21.6fd0ef2a.jpeg";